import React from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import AlertMessage from '../../components/ui/AlertMessage';
import CheckinStep from '../../components/ui/CheckinStep';
import { useAuth } from '../../contexts/AuthContext'; // Import useAuth to get user data

// SVG Icons from the provided HTML graphic (copied from HomeAdminScreen for consistency)
const AlertInfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 25 24" fill="#01844B">
        <path d="M12.5 2L1.5 21H23.5M12.5 6L20.03 19H4.97M11.5 10V14H13.5V10M11.5 16V18H13.5V16" fill="#000000" />
    </svg>
);

const StatusCompletedIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="me-2" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" alt="Completado">
        <title>Completado</title>
        <circle cx="8" cy="8" r="8" fill="#01844B" />
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" fill="#FFFFFF" />
    </svg>
);

const StatusPendingIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-muted me-2" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" alt="Pendiente">
        <title>Pendiente</title>
        <circle cx="8" cy="8" r="7" />
    </svg>
);

const HomeAgentScreen = () => {
    const { user } = useAuth(); // Get user object from AuthContext
    const agentName = user?.name || "Asesor"; // Use user's name if available, fallback to "Asesor"

    // Placeholder data for agent-specific steps
    const agentCheckinSteps = [
        { id: 1, text: "Registro completo", status: "completed" },
        { id: 2, text: "Completar formulario Sello Checkin", status: "pending" }, // This might be a placeholder, adjust as needed for agent tasks
    ];

    return (
        <DashboardLayout activeMenuItem="Inicio" userName={agentName} userRole="agent">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-0">¡Bienvenido/a, {agentName}!</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                    {/* Link to agent-specific evaluation form or a primary action */}
                    <Link to="/agent/evaluation-form" className="btn btn-success d-flex align-items-center">
                        Ingresar al formulario evaluación
                    </Link>
                </div>
            </div>

            {/* Alert message for agents */}
            <AlertMessage
                message="Recuerda realizar todos los talleres de capacitación antes de postular al sello CheckIn"
                icon={<AlertInfoIcon />} // Using the custom SVG icon
            />

            <h3 className="mb-3 mt-4">Tu ruta como asesor</h3>
            <p className="mb-4 text-muted">Tu información paso a paso</p>

            <div className="list-group gap-3">
                {agentCheckinSteps.map(step => (
                    <CheckinStep
                        key={step.id}
                        text={step.text}
                        status={step.status}
                        completedIcon={<StatusCompletedIcon />}
                        pendingIcon={<StatusPendingIcon />}
                    />
                ))}
            </div>

            {/* The copyright section is typically handled by the DashboardLayout's footer */}
            {/* If not, you can uncomment and place it here: */}
            {/* <div className="copyright mt-auto text-center">
                <p>© 2025 Checkin. Todos los derechos reservados. Desarrollado por <a href="https://antudigital.cl" target="_blank" rel="noopener noreferrer">Antü Digital</a></p>
            </div> */}
        </DashboardLayout>
    );
};

export default HomeAgentScreen;